module.exports = __webpack_public_path__ + "img/CHE.5955749b.svg";